import type { RegisterUser } from '@indutrust/auth-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Register flow events for the authentication system.
 *
 * These events drive the reactive user registration process from form submission
 * to successful account creation and automatic authentication.
 *
 * @example
 * const dispatch = injectDispatch(registerEvents);
 * dispatch.registerRequested({ email: 'new@example.com', password: 'secret', name: 'User' });
 */
export const registerEvents = eventGroup({
  source: 'auth.register',
  events: {
    registerRequested: type<RegisterUser>(),
    registerSucceeded: type<{
      accessToken: string;
    }>(),
    registerFailed: type<{
      error: string;
    }>(),
  },
});
